<template>
	<div>
		<el-card shadow="never" class="br-10px">
			<div slot="header" class="clearfix flex flex-b cardHeader">
				<h4>用户数据</h4>
				<div class="flex">
					<el-date-picker size="small" style="margin-left: 20px;width: 250px;" format='yyyy-MM-dd'
						value-format='yyyy-MM-dd' v-model="dataForm.userStatDay" @change="getBillUserStat()"
						placeholder="选择日期">
					</el-date-picker>
				</div>
			</div>
			<div class="flex flex-b">
				<el-card shadow="never" class="w-32">
					<div class="topTitle">总用户数</div>
					<div class="topVal">{{billUserStat.user.num}}<span style="font-size: 16px;">人</span></div>
					<div class="split"></div>
					<div class="flex">
						<div class="tex">较昨日</div>
						<img src="../../assets/up.png" style="width: 15px;height: auto;margin: 0 10px;" />
						<div class="tex">{{billUserStat.user.persent}}%</div>
					</div>
				</el-card>
				<el-card shadow="never" class="w-32">
					<div class="topTitle">今日新增用户</div>
					<div class="topVal">{{billUserStat.register.num}}<span style="font-size: 16px;">人</span></div>
					<div class="split"></div>
					<div class="flex">
						<div class="tex">较昨日</div>
						<img src="../../assets/down.png" style="width: 15px;height: auto;margin: 0 10px;" />
						<div class="tex">{{billUserStat.register.persent}}%</div>
					</div>
				</el-card>
				<el-card shadow="never" class="w-32">
					<div class="topTitle">今日活跃用户数</div>
					<div class="topVal">{{billUserStat.login.num}}<span style="font-size: 16px;">人</span></div>
					<div class="split"></div>
					<div class="flex">
						<div class="tex">较昨日</div>
						<img src="../../assets/down.png" style="width: 15px;height: auto;margin: 0 10px;" />
						<div class="tex">{{billUserStat.login.persent}}%</div>
					</div>
				</el-card>
			</div>
		</el-card>
		<div class="flex-b flex-only" style="margin-top: 20px;">
			<div class="w-69">

				<el-card shadow="never" class="box-card br-10px" style="margin-top: 15px;">
					<div slot="header" class="clearfix flex flex-b cardHeader">
						<h4>用户排行</h4>
						<div class="flex">
							<el-date-picker size="small" style="margin-left: 20px;width: 250px;" format='yyyy-MM-dd'
								@change="getBillUserRank()" value-format='yyyy-MM-dd' v-model="dataForm.rankDay"
								placeholder="选择日期">
							</el-date-picker>
						</div>
					</div>
					<div class="flex flex-b">
						<div class="w-48">
							<div class="subTitle">连续登录天数</div>
							<el-table size='small' :data="billUserRank.user" border style="width: 100%">
								<el-table-column type="index" label="排名" align="center">
								</el-table-column>
								<el-table-column prop="name" label="昵称" align="center">
								</el-table-column>
								<el-table-column prop="day" label="连续登陆天数" align="center">
								</el-table-column>
							</el-table>
						</div>
						<div class="ssplit"></div>
						<div class="w-48">
							<div class="subTitle">积分总数</div>
							<el-table size='small' :data="billUserRank.score" border style="width: 100%">
								<el-table-column type="index" label="排名" align="center">
								</el-table-column>
								<el-table-column prop="name" label="昵称" align="center">
								</el-table-column>
								<el-table-column prop="left_score" label="积分总数" align="center">
								</el-table-column>
							</el-table>
						</div>
					</div>
				</el-card>

				<el-card shadow="never" class="box-card br-10px" style="margin-top: 20px;">
					<div slot="header" class="clearfix flex flex-b cardHeader">
						<h4>课程数据</h4>
						<div class="flex">
							课程分类：
							<el-select clearable size="small" style="width: 100px;margin-right: 20px;"
								@change="getBillCourseStat()" v-model="dataForm.course_cate_uuid" placeholder="请选择">
								<el-option v-for="item in courseTypes" :key="item.uuid" :label="item.name"
									:value="item.uuid">
								</el-option>
							</el-select>
							截止到：
							<el-date-picker size="small" style="width: 130px;" format='yyyy-MM-dd'
								@change="getBillCourseStat()" value-format='yyyy-MM-dd' v-model="dataForm.courseDay"
								placeholder="选择日期">
							</el-date-picker>
						</div>
					</div>
					<div class="flex flex-a">
						<el-card shadow="never" class="br-10px w-32">
							<div class="flex">
								<img src="../../assets/jy.png" style="width: 60px;height: 60px;" />
								<div style="margin-left: 30px;">
									<div class="val" style="font-size: 32px;">{{courseData.course}}</div>
									<div class="title" style="font-size: 14px;">课程总数</div>
								</div>
							</div>
						</el-card>
						<el-card shadow="never" class="br-10px w-32">
							<div class="flex">
								<img src="../../assets/jy.png" style="width: 60px;height: 60px;" />
								<div style="margin-left: 30px;">
									<div class="val" style="font-size: 32px;">{{courseData.course_order}}</div>
									<div class="title" style="font-size: 14px;">课程订单数（笔）</div>
								</div>
							</div>
						</el-card>
						<el-card shadow="never" class="br-10px w-32">
							<div class="flex">
								<img src="../../assets/jy.png" style="width: 60px;height: 60px;" />
								<div style="margin-left: 30px;">
									<div class="val" style="font-size: 32px;">{{courseData.course_score}}</div>
									<div class="title" style="font-size: 14px;">订单积分金额</div>
								</div>
							</div>
						</el-card>
					</div>
				</el-card>

				<el-card shadow="never" class="box-card br-10px" style="margin-top: 15px;height: 545px;">
					<div slot="header" class="clearfix flex flex-b cardHeader">
						<h4>新增订单趋势</h4>
						<div class="flex">
							<el-date-picker size="small" style="margin-left: 20px;width: 250px;" format='yyyy-MM-dd'
								@change="getBillCourseRankQs()" v-model="dataForm.orderqsTime" value-format='yyyy-MM-dd'
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker>
						</div>
					</div>
					<div class="chart-container">
						<div ref="chartddqs" style="width: 100%; height: 400px;"></div>
					</div>
				</el-card>
				<el-card shadow="never" class="box-card br-10px" style="height: 755px;margin-top: 15px;">
					<div slot="header" class="clearfix flex flex-b cardHeader">
						<h4>营收排行</h4>
						<div class="flex">
							<!-- <el-date-picker size="small" style="margin-left: 20px;width: 250px;" format='yyyy-MM-dd'
								value-format='yyyy-MM-dd' v-model="dataForm.courseRankDay" @change="getBillCourseRank()"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker> -->

							<el-date-picker size="small" style="width: 130px;" format='yyyy-MM-dd'
								@change="getBillCourseRank()" value-format='yyyy-MM-dd' v-model="dataForm.courseRankDay"
								placeholder="选择日期">
							</el-date-picker>
						</div>
					</div>
					<div class="flex flex-b" style="margin-bottom: 30px;">
						<h3>课程订单数排行 Top 5</h3>
						<h3>订单数：{{courseRank.course_order_num.total}}笔</h3>
					</div>

					<div v-if="courseRank.course_order_num" class="flex flex-b progress"
						v-for="item in courseRank.course_order_num.list">
						<div class="ptitle">{{item.name}}</div>
						<div style="width: 80%;">
							<el-progress color="#63a103" :format='format1' :stroke-width='20'
								:percentage="parseInt(item.num)"></el-progress>
						</div>
					</div>

					<div class="flex flex-b" style="margin-bottom: 30px;margin-top: 60px;">
						<h3>课程积分销售额排行 Top 5</h3>
						<h3>销售额：{{courseRank.course_score.total}}积分</h3>
					</div>
					<div v-if="courseRank.course_score" class="flex flex-b progress"
						v-for="item in courseRank.course_score.list">
						<div class="ptitle">{{item.name}}</div>
						<div style="width: 80%;">
							<el-progress color="#63a103" :format='format2' :stroke-width='20'
								:percentage="parseInt(item.score)"></el-progress>
						</div>
					</div>
				</el-card>
			</div>

			<div class="w-30">
				<el-card shadow="never" class="box-card br-10px" style="margin-top: 15px;">
					<div slot="header" class="clearfix flex flex-b">
						<h4>用户会员类型分布</h4>
						<div class="flex">
							截止到：
							<el-date-picker size="small" style="margin-left: 20px;width: 130px;" format='yyyy-MM-dd'
								@change="getBillUserMember()" value-format='yyyy-MM-dd' v-model="dataForm.m_time"
								placeholder="选择日期">
							</el-date-picker>
						</div>
					</div>
					<div class="chart-container">
						<div ref="chartlxfx" style="width: 100%; height: 240px;"></div>
					</div>
				</el-card>
				<el-card shadow="never" class="box-card br-10px" style="margin-top: 15px;">
					<div slot="header" class="clearfix flex flex-b">
						<h4>付费会员数量分布</h4>
						<div class="flex">
							<el-date-picker size="small" style="margin-left: 20px;width: 130px;" format='yyyy-MM-dd'
								@change="getBillUserMember1()" value-format='yyyy-MM-dd' v-model="dataForm.m_time1"
								placeholder="选择日期">
							</el-date-picker>
						</div>
					</div>
					<div class="chart-container">
						<div ref="chartff" style="width: 100%; height: 280px;"></div>
					</div>

					<el-table :data="member_nums" style="width: 100%">
						<el-table-column prop="date" align="center" label="会员等级">
							<template slot-scope="scope">
								<div class="flex flex-c-c">
									<div style="width: 5px;height: 5px;border-radius: 50%;background-color: #FF6384;">
									</div>
									<div style="font-size: 14px;margin-left: 5px;">{{scope.row.name}}</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="num" align="center" label="会员总数">
						</el-table-column>
						<el-table-column prop="address" align="center" label="总数占比">
						</el-table-column>
					</el-table>
				</el-card>


				<el-card shadow="never" class="box-card br-10px" style="margin-top: 15px;">
					<div slot="header" class="clearfix flex flex-b">
						<h4>培训数据</h4>
					</div>
					<div class="chart-container">
						<div ref="chartpx" style="width: 100%; height: 240px;"></div>
					</div>
				</el-card>

				<el-card shadow="never" class="box-card br-10px" style="margin-top: 15px;height: 500px;">
					<div slot="header" class="clearfix flex flex-b">
						<h4>培训收入明细</h4>
						<div class="flex">
							<el-date-picker size="small" style="margin-left: 20px;width: 250px;" format='yyyy-MM-dd'
								value-format='yyyy-MM-dd' v-model="dataForm.tradingTimes" @change="tradingTimesChange"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker>
						</div>
					</div>
					<div class="chart-container">
						<div ref="chart1" style="width: 100%; height: 400px;"></div>
					</div>
				</el-card>
			</div>
		</div>

	</div>
</template>

<script>
	import * as echarts from 'echarts';
	import operations from "@/mixins/operations";
	import {
		getBillUserStat,
		getBillUserRank,
		getBillCourseStat,
		getBillUserMember,
		getBillTrainStat,
		getBillTrainOrder,
		getBillCourseRank,
		getBillCourseRankQs
	} from "@/api/statics"
	import {
		getCourseCateList
	} from "@/api/course"
	import {
		mapState
	} from "vuex";
	import utils from "@/jslibs/utils"

	export default {
		name: "hotellist",
		mixins: [operations],
		data() {
			return {
				dataForm: {
					userStatDay: '',
					rankDay: '',
					course_cate_uuid: '',
					courseDay: '',
					m_time: '',
					m_time1: '',
					end_time: '',
					start_time: '',
					tradingTimes: '',
					courseRankDay: '',
					orderqsTime: '',
				},
				activeName: 'first',
				tabPosition: '',
				dateTime: '',
				value: '',
				value1: '',
				courseTypes: [{
					value: '月度',
					label: '月度'
				}],
				billUserStat: {
					login: {
						num: 0,
						persent: 0
					},
					user: {
						num: 0,
						persent: 0
					},
					register: {
						num: 0,
						persent: 0
					}
				},
				billUserRank: {
					user: [],
					score: []
				},
				courseData: {
					course: 0,
					course_order: 0,
					course_score: 0
				},
				member_nums: [],
				courseRank: {
					course_order_num: {
						list: [],
						total: 0
					},
					course_score: {
						list: [],
						total: 0
					}
				}
			};
		},
		components: {},
		mounted() {
			this.getCourseCateList()
			this.getBillUserStat()
			this.getBillUserRank()
			this.getBillCourseStat()
			this.getBillUserMember()
			this.getBillUserMember1()
			this.getBillTrainStat()
			this.getBillTrainOrder()
			this.getBillCourseRank()
			this.getBillCourseRankQs()
		},
		computed: {
			...mapState(["imgDomain"])
		},
		methods: {
			//热卖课程
			async getBillCourseRank() {
				const {
					status,
					data
				} = await getBillCourseRank({
					day: this.dataForm.courseRankDay
				});
				if (status !== 200) return;
				this.courseRank = data.result
				// this.courseRank.course_order_num.list.forEach(item=>{
				// 	item.num = parseInt(item.num)
				// })
				// this.courseRank.course_score.list.forEach(item=>{
				// 	item.score = parseInt(item.score)
				// })
			},
			tradingTimesChange(e) {
				if (e) {
					this.dataForm.start_time = e[0]
					this.dataForm.end_time = e[1]
				} else {
					this.dataForm.start_time = ''
					this.dataForm.end_time = ''
				}
				this.getBillTrainOrder()
			},
			//培训收入明细
			async getBillTrainOrder() {
				const {
					status,
					data
				} = await getBillTrainOrder({
					start_time: this.dataForm.start_time,
					end_time: this.dataForm.end_time
				});
				if (status !== 200) return;
				this.initChart1(data.result)
			},
			//培训数据
			async getBillTrainStat() {
				const {
					status,
					data
				} = await getBillTrainStat({});
				if (status !== 200) return;
				this.initChart2(data.result)
			},
			//订单趋势
			async getBillCourseRankQs() {
				const {
					status,
					data
				} = await getBillCourseRankQs({
					start_time: this.dataForm.orderqsTime?this.dataForm.orderqsTime[0]:'',
					end_time: this.dataForm.orderqsTime?this.dataForm.orderqsTime[1]:'',
					type: 2
				});
				if (status !== 200) return;
				this.initChart3(data.result)
			},
			//用户会员类型分布
			async getBillUserMember() {
				const {
					status,
					data
				} = await getBillUserMember({
					m_time: this.dataForm.m_time
				});
				if (status !== 200) return;
				this.initChart4(data.result.member_type)
			},
			//付费会员数量分布
			async getBillUserMember1() {
				const {
					status,
					data
				} = await getBillUserMember({
					m_time: this.dataForm.m_time1
				});
				if (status !== 200) return;
				this.initChart(data.result.member_num)
				this.member_nums = data.result.member_num.data
			},
			//课程分类
			async getCourseCateList() {
				const {
					status,
					data
				} = await getCourseCateList({
					page_index: 1,
					page_size: 999
				});
				if (status !== 200) return;
				this.courseTypes = data.result.data
			},
			//课程数据
			async getBillCourseStat() {
				const {
					status,
					data
				} = await getBillCourseStat({
					day: this.dataForm.courseDay,
					course_cate_uuid: this.dataForm.course_cate_uuid
				});
				if (status !== 200) return;
				this.courseData = data.result
			},
			//用户数据
			async getBillUserStat() {
				const {
					status,
					data
				} = await getBillUserStat({
					day: this.dataForm.userStatDay
				});
				if (status !== 200) return;
				this.billUserStat = data.result
			},
			//用户排行
			async getBillUserRank() {
				const {
					status,
					data
				} = await getBillUserRank({
					day: this.dataForm.rankDay
				});
				if (status !== 200) return;
				this.billUserRank = data.result
			},
			format1(percentage) {
				return `${percentage}笔`;
			},
			format2(percentage) {
				return `${percentage}积分`;
			},
			//付费会员数量分布
			initChart(datas) {
				const chartDom = this.$refs.chartff;
				const myChart = echarts.init(chartDom);
				const names = datas.data.map(item => item.name)
				const values = []
				datas.data.forEach(item => {
					values.push({
						value: item.num,
						name: item.name,
						itemStyle: {
							color: '#36A2EB'
						}
					})
				})
				const option = {
					title: {
						text: datas.total,
						subtext: '全部付费会员',
						left: 'center',
						top: 'center',
						textStyle: {
							fontSize: 24,
							color: '#333',
							fontWeight: 'bold',
						},
						subtextStyle: {
							fontSize: 14,
							color: '#999'
						}
					},
					tooltip: {
						trigger: 'item',
						formatter: '{b}: {c} ({d}%)'
					},
					legend: {
						show: false,
						orient: 'vertical',
						right: 10,
						top: 'middle',
						data: names
					},
					series: [{
						name: '会员分布',
						type: 'pie',
						radius: ['50%', '70%'],
						avoidLabelOverlap: false,
						itemStyle: {
							borderRadius: 10,
							borderColor: '#fff',
							borderWidth: 2
						},
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '18',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: values
					}]
				};

				myChart.setOption(option);

				// 响应式调整
				window.addEventListener('resize', function() {
					myChart.resize();
				});
			},
			//培训收入明细
			initChart1(datas) {
				const chartDom = this.$refs.chart1;
				const myChart = echarts.init(chartDom);

				const option = {
					title: {
						text: '',
						left: 'center'
					},
					tooltip: {
						trigger: 'axis',
						formatter: params => `
				      ${params[0].axisValue}<br/>
				      ${params[0].marker} ${params[0].seriesName}: ${params[0].value}<br/>
				      ${params[1].marker} ${params[1].seriesName}: ${params[1].value}
				    `
					},
					legend: {
						data: ['培训金额收入', '培训积分收入'],
						itemStyle: {
							borderWidth: 1,
							borderColor: params => params === '会员收入' ? '#5470C6' : '#91CC75'
						},
						itemWidth: 8,
						itemHeight: 8,
						textStyle: {
							color: '#333',
							fontSize: 12
						},
						left: 'left',
					},
					xAxis: {
						type: 'category',
						data: datas.list_date,
						axisLabel: {
							textStyle: {
								color: '#999' // 设置 X 轴文字颜色为橙红色
							}
						},
						axisLine: {
							lineStyle: {
								color: '#999'
							}
						}
					},
					yAxis: {
						type: 'value',
						interval: 250,
						axisLabel: {
							formatter: '{value}'
						},
						axisLabel: {
							textStyle: {
								color: '#999' // 设置 X 轴文字颜色为橙红色
							}
						},
						axisLine: {
							lineStyle: {
								color: '#fff'
							}
						},
						splitLine: {
							lineStyle: {
								color: '#eee'
							}
						},
					},
					series: [{
							name: '培训金额收入',
							type: 'bar',
							barWidth: '30%',
							data: datas.price,
							itemStyle: {
								color: '#5470C6'
							}
						},
						{
							name: '培训积分收入',
							type: 'bar',
							barWidth: '30%',
							data: datas.score,
							itemStyle: {
								color: '#91CC75'
							}
						}
					]
				}

				myChart.setOption(option);

				// 响应式调整
				window.addEventListener('resize', function() {
					myChart.resize();
				});
			},
			//用户类型分析
			initChart4(datas) {

				const chartDom = this.$refs.chartlxfx;
				const myChart = echarts.init(chartDom);

				const option = {
					title: {
						text: datas.fee + datas.pay,
						subtext: '总用户数',
						left: 'center',
						top: 'center',
						textStyle: {
							fontSize: 24,
							color: '#333',
							fontWeight: 'bold',
						},
						subtextStyle: {
							fontSize: 14,
							color: '#999'
						}
					},
					tooltip: {
						trigger: 'item',
						formatter: '{b}: {c} ({d}%)'
					},
					legend: {
						itemWidth: 8,
						itemHeight: 8,
						left: 10,
						top: 0,
						data: ['基础会员', '付费会员']
					},
					series: [{
						name: '用户会员类型分布',
						type: 'pie',
						radius: ['50%', '70%'],
						avoidLabelOverlap: false,
						itemStyle: {
							borderRadius: 10,
							borderColor: '#fff',
							borderWidth: 2
						},
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '18',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: [{
								value: datas.fee,
								name: '基础会员',
								itemStyle: {
									color: '#FF6384'
								}
							},
							{
								value: datas.pay,
								name: '付费会员',
								itemStyle: {
									color: '#36A2EB'
								}
							},
						]
					}]
				};

				myChart.setOption(option);

				// 响应式调整
				window.addEventListener('resize', function() {
					myChart.resize();
				});

			},
			//培训数据
			initChart2(datas) {
				const chartDom = this.$refs.chartpx;
				const myChart = echarts.init(chartDom);
				const names = datas.list.map(item => item.status == 1 ? '报名中' : item.status == 2 ? '进行中' : '已结束')
				const values = []
				datas.list.forEach(item => {
					values.push({
						value: item.num,
						name: item.status == 1 ? '报名中' : item.status == 2 ? '进行中' : '已结束',
						itemStyle: {
							color: item.status == 1 ? '#FF6384' : item.status == 2 ? '#36A2EB' : '#FFCE56'
						}
					})
				})
				const option = {
					title: {
						text: datas.all,
						subtext: '培训总数',
						left: 'center',
						top: 'center',
						textStyle: {
							fontSize: 24,
							color: '#333',
							fontWeight: 'bold',
						},
						subtextStyle: {
							fontSize: 14,
							color: '#999'
						}
					},
					tooltip: {
						trigger: 'item',
						formatter: '{b}: {c} ({d}%)'
					},
					legend: {
						orient: 'vertical',
						right: 10,
						top: 'middle',
						data: names
					},
					series: [{
						name: '培训数据',
						type: 'pie',
						radius: ['50%', '70%'],
						avoidLabelOverlap: false,
						itemStyle: {
							borderRadius: 10,
							borderColor: '#fff',
							borderWidth: 2
						},
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '18',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: values
					}]
				};

				myChart.setOption(option);

				// 响应式调整
				window.addEventListener('resize', function() {
					myChart.resize();
				});
			},
			//新增订单趋势
			initChart3(item) {

				const chartDom = this.$refs.chartddqs;
				const myChart = echarts.init(chartDom);

				const option = {
					title: {
						text: '',
						left: 'center',
						top: 0
					},
					tooltip: {
						trigger: 'axis',
						formatter: function(params) {
							let result = params[0].axisValue + '<br/>';
							params.forEach(item => {
								result += `${item.marker} ${item.seriesName}: ${item.value}<br/>`;
							});
							return result;
						}
					},
					legend: {
						data: ['订单数量'],
						left: 'left',
						icon: 'circle',
						itemWidth: 8,
						itemHeight: 8,
						textStyle: {
							color: '#333',
							fontSize: 12
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						top: '20%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: item.date,
						name: '',
						axisLabel: {
							textStyle: {
								color: '#999' // 设置 X 轴文字颜色为橙红色
							}
						},
						axisLine: {
							lineStyle: {
								color: '#999'
							}
						}
					},
					yAxis: {
						type: 'value',
						name: '',
						interval: 250,
						axisLabel: {
							formatter: '{value}'
						},
						splitLine: {
							lineStyle: {
								color: '#eee'
							}
						},
						axisLabel: {
							textStyle: {
								color: '#999' // 设置 X 轴文字颜色为橙红色
							}
						},
						axisLine: {
							lineStyle: {
								color: '#fff'
							}
						}
					},
					series: [{
						name: '订单数量',
						type: 'line',
						data: item.order_num,
						itemStyle: {
							color: '#5470C6'
						},
						smooth: false,
						symbol: 'none',
					}, ]
				};

				myChart.setOption(option);

				// 响应式调整
				window.addEventListener('resize', function() {
					myChart.resize();
				});

			},
		}
	};
</script>

<style lang="less" scoped>
	@import "~@/assets/styles/variables.less";
	@import "~@/assets/styles/mixins.less";

	.title {
		font-size: 16px;
		color: #999;
	}

	.val {
		font-size: 38px;
		color: #000;
		font-weight: 600;
	}

	.card {
		padding: 20px 0;
		position: relative;
		border-radius: 10px;
	}

	.br-10px {
		border-radius: 10px;
	}

	.mxbtn {
		position: absolute;
		right: 20px;
		top: 20px;
		font-size: 16px;
		color: #02aef1;
		font-weight: 600;
	}

	.chart-container {
		width: 100%;
		box-sizing: border-box;
	}

	/deep/ .el-card__header {
		background-color: #f9f9f9;
	}

	.headCard {
		/deep/ .el-card__header {
			background-color: transparent;
			padding: 10px 20px;
		}

		/deep/ .el-tabs__nav-wrap::after {
			background-color: transparent;
		}

		/deep/ .el-tabs__item {
			height: auto;
			line-height: 30px;
			font-size: 16px;
			font-weight: 600;
		}

		/deep/ .el-tabs__header {
			margin: 0;
		}
	}

	.ptitle {
		color: #616161;
		font-size: 14px;
	}

	.progress {
		margin-top: 30px;
	}

	/deep/ .el-progress__text {
		font-size: 14px !important;
		margin-left: 10px !important;
	}

	.hyxs {
		/deep/ .el-progress-bar__outer {
			border-radius: 0px;
		}

		/deep/ .el-progress-bar__inner {
			border-radius: 0px;
		}

		/deep/ .el-progress-bar__innerText {
			font-size: 14px !important;
			color: #fff !important;
		}
	}

	.topTitle {
		font-size: 16px;
		color: #999;
	}

	.topVal {
		font-size: 32px;
		color: #000;
		margin-top: 5px;
	}

	.split {
		margin: 10px 0;
		left: 5%;
		height: 1px;
		background-color: #999;
	}

	.tex {
		font-size: 14px;
		color: #999;
	}

	.subTitle {
		margin-bottom: 20px;
		height: 20px;
	}

	.ssplit {
		width: 1px;
		height: 285px;
		background-color: #d8d8d8;
	}

	::v-deep .el-progress {
		display: flex;
		align-items: center;
	}

	::v-deep .el-progress__text {
		white-space: nowrap;
	}
</style>